const refundStatus = {
  OPEN: 'OPEN',
  PROCESSING: 'PROCESSING',
  CLOSED: 'CLOSED',
  CANCELLED: 'CANCELLED'
};

module.exports = refundStatus;
